import { render } from "./IBoard.vue?vue&type=template&id=35432ccc&scoped=true"
import script from "./IBoard.vue?vue&type=script&lang=js"
export * from "./IBoard.vue?vue&type=script&lang=js"

import "./IBoard.vue?vue&type=style&index=0&id=35432ccc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-35432ccc"

export default script